import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

function ProtectedRoute({ redirectPath = "/login" }) {
  const { user } = useSelector((state) => state.auth);
  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />; // renders nested routes if authenticated
}

export default ProtectedRoute;
